// extracted by mini-css-extract-plugin
module.exports = {"root":"UploadImagePlaceholder_root__KlNx6","error":"UploadImagePlaceholder_error__JW6gF","icon":"UploadImagePlaceholder_icon__1NaYb"};